import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ArticlesSection from "@/components/ArticlesSection";
import TestimonialSection from "@/components/TestimonialSection";
import FAQSection from "@/components/FAQSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <HeroSection />
      <ArticlesSection />
      <TestimonialSection />
      {/* <FAQSection /> */}
      <CTASection />
      <Footer />
    </div>
  );
};

export default Index;
